// 获取火星排行榜
export const GETMPRANKLIST = 'get-mprank-list'
